import { useState } from "react";
import { FormInput } from "components/ui/form/FormInput";
import { useForm } from "react-hook-form";
import Form from "components/ui/form/Form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { emailAddress, impersonateToken } from "utilities/formSchemas";
import { Button } from "components/ui/button/Button";
import { impersonateData, usePostImpersonateMutation } from "./impersonateService";
import { ErrorType } from "utilities/error";
import { setCredentials, setIsImpersonating } from "features/authSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";


const formSchema = z.object({
  toEmailAddress: emailAddress,
  token: impersonateToken,
});
export default function Impersonate(){
    const {
        register,handleSubmit,formState: { errors }} = useForm<{ toEmailAddress: string; token: string }>({
        resolver: zodResolver(formSchema),
         defaultValues: {
          toEmailAddress: "",
          token: ""
        },
      });
      const dispatch = useDispatch(); 
      const navigate = useNavigate();           
      const [error, setError] = useState(0);      
      const [sendRequest, { isSuccess, data, isLoading, isError }] = usePostImpersonateMutation();
      const onSubmit = (data: impersonateData) =>
          sendRequest(data)
            .unwrap()
            .catch((error: ErrorType) => {
              setError(error.status);
            });
      if (isSuccess && data) {            
              dispatch(
                setCredentials({
                  ...data,
                })
              );
              dispatch(setIsImpersonating(true));
              navigate("/my-loans", { replace: true });
            
          }    
    return <Form onSubmit={handleSubmit(async (data:impersonateData) => {
                    await onSubmit({
                      toEmailAddress: data.toEmailAddress,
                      token: data.token,
                    });
                  })}
                >
                  <FormInput
                    formHandle={register("toEmailAddress")}
                    inputProps={{
                      name: "toEmailAddress",
                      placeholder: "Enter emailAddress of the person to impersonate",
                      label: "Email Address",
                      errorMessage: errors.toEmailAddress?.message as string,
                    }}
                  />
                  <FormInput
                    formHandle={register("token")}
                    inputProps={{
                      name: "token",
                      placeholder: "Enter impersonate token",
                      label: "Impersonate Token",
                      errorMessage: errors.token?.message as string,
                    }}
                  />
                  <Button title="Continue" className="login-btn" />
            </Form>
              
}